import { useQuery } from '@tanstack/react-query';
import { getTeamComplianceStatus } from '../../../services/MoodleService';
import { moodleQueryKeys } from '../all-query-keys';

export const useGetTeamComplianceStatus = ({
  page = 0,
  size = 10,
  state,
  employeeName,
  enabled = true,
} = {}) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: moodleQueryKeys.getTeamComplianceStatus(page, size, state, employeeName),
    queryFn: () => getTeamComplianceStatus(page, size, state, employeeName),
    enabled,
  });

  const reports = data?.data?.content || [];
  const totalPages = data?.data?.totalPages || 0;
  const totalElements = data?.data?.totalElements || 0;

  return {
    reports,
    totalPages,
    totalElements,
    loading: isLoading,
    refetch,
  };
};
